import React from 'react';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import IconButton from '@mui/material/IconButton';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import IRole from '../../interfaces/Role';
import Collapse from '@mui/material/Collapse';
import RolePermissionsTable from './RolePermissionsTable';
import RemoveRoleButton from './RemoveRoleButton';

interface Props {
  role: IRole;
  user_id: string;
  user_email: string;
  mutateRoles: () => void | Promise<void>;
}

const RoleUserTableRow = ({ role, user_id, user_email, mutateRoles }: Props) => {
  const [open, setOpen] = React.useState(false);

  return (
    <>
      <TableRow key={role.id} sx={{ td: { border: 0 } }}>
        <TableCell>
          <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell>{role.name}</TableCell>
        <TableCell>{role.description}</TableCell>
        <TableCell align="right">
          <RemoveRoleButton
            role={role}
            user_id={user_id}
            user_email={user_email}
            mutateRoles={mutateRoles}
          />
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <RolePermissionsTable role_id={role.id} />
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
};

export default RoleUserTableRow;
